const ARCHIVED = 'archived';
const REGISTER_STATUS = {
  New: 'New',
  WorkingOn: 'Working On',
  AwaitingDocs: 'Awaiting Docs',
  AwaitingInfo: 'Awaiting Info',
  PendingReview: 'Pending Review',
  Registered: 'Registered',
  Dealing: 'Dealing',
  Incomplete: 'Incomplete',
  RecipientAwaitingDocs: 'Recipient Awaiting Docs',
  Default: 'Default',
  Inactive: 'Inactive',
  Converted: 'Converted',
  RegistrationFailed: 'Registration Failed',
};

const CONVERSION_STATUS = {
  SendCompliancePending: 'send_compliance_pending',
  SendApproved: 'send_approved',
  SendArchived: 'send_archived',
  AwaitingFunds: 'awaiting_funds',
  FundsSent: 'funds_sent',
  FundsArrived: 'funds_arrived',
  TradeSettled: 'trade_settled',
  Closed: 'closed',
};

const CUSTOMER_FACING_CONVERSION_STATUS = {
  awaiting_funds: {
    name: 'AwaitingFunds',
    meaning:
      'Trade has been created within Sends systems and is now Awaiting Funds. There is a 48hr window to fund a trade before rollover/cancellation fees will accrue.',
  },
  send_compliance_pending: {
    name: 'CompliancePending',
    meaning:
      'All trades are risk categorised based on factors such as size, currency, country, prior trade activity for the user etc. If a trade hits one of Sends compliance flags Send will review the case and reach out via established channels (ie slack) if a follow-up is required. If no followup is required, the trade will be approved and automatically pushed to the next stage.',
  },
  send_approved: {
    name: 'Approved',
    meaning: 'Trade is approved from compliance and will be booked by Send',
  },
  send_archived: {
    name: 'Cancelled',
    meaning: 'Trade has been cancelled before being formally booked and therefore no cancellation fees apply',
  },
  funds_sent: {
    name: 'FundsSent',
    meaning: 'Status has been deprecated, please remove',
  },
  funds_arrived: {
    name: 'FundsArrived',
    meaning: 'Status has been deprecated, please remove',
  },
  trade_settled: {
    name: 'TradeSettled',
    meaning:
      'The trade has been completed and relevant funds have been disbursed to the users Send accounts. If a payment has been linked to the trade via attaching a beneficiary this status will trigger the creation of a payment.',
  },
  closed: {
    name: 'Cancelled',
    meaning: 'The trade has been cancelled. Cancellation fees may apply',
  },
};

const PAYMENT_STATUS = {
  New: 'new',
  SendArchived: 'send_archived',
  SendApproved: 'send_approved',
  Failed: 'failed',
  Completed: 'completed',
  AwaitingFunds: 'awaiting_funds',
  SendCompliancePending: 'send_compliance_pending',
  ReadyToSend: 'ready_to_send',
  Suspended: 'suspended',
  Released: 'released',
  AwaitingAuthorisation: 'awaiting_authorisation',
  Submitted: 'submitted',
  Authorised: 'authorised',
  Deleted: 'deleted',
};

const REGISTRATION_STATUS = {
  New: 'New',
  WorkingOn: 'Working On',
  AwaitingDocs: 'Awaiting Docs',
  AwaitingInfo: 'Awaiting Info',
  PendingReview: 'Pending Review',
  Incomplete: 'Incomplete',
  RegistrationFailed: 'Registration Failed',
  Inactive: 'Inactive',
  Registered: 'Registered',
  Dealing: 'Dealing',
  Boomerang: 'Boomerang',
  Converted: 'Converted',
};

const BENEFICIARY_STATUS = {
  New: 'New',
  AwaitingInfo: 'Awaiting Info',
  AwaitingDocs: 'Awaiting Docs',
  Verified: 'Verified',
  BeneficiaryFailed: 'Beneficiary Failed',
  Deleted: 'Deleted',
};

module.exports = {
  ARCHIVED,
  REGISTER_STATUS,
  CONVERSION_STATUS,
  CUSTOMER_FACING_CONVERSION_STATUS,
  PAYMENT_STATUS,
  REGISTRATION_STATUS,
  BENEFICIARY_STATUS,
};
